// Cliente de la API pública de solo lectura (mod_checklist/free/mapa/*). Sin sesión: la URL lleva
// /free/ y el sistema se indica con REACT_APP_SISTEMA (pda_ch_sistemas.codigo, ej. "MUNICIPIO"); el servidor,
// si no, usa el único sistema publicado. La empresa sale del dominio del sitio (eco_dominio).
const SITIO = process.env.REACT_APP_SISTEMA || "";
const BASE = (process.env.REACT_APP_URL_API || "http://test-api-emp.mispymes.cl/api/mod_checklist").replace(/\/$/, "");

export async function post(ruta, param = {}, signal) {
    const resp = await fetch(`${BASE}/free/mapa/${ruta}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ param: SITIO ? { ...param, sitio: SITIO } : param }),
        signal,
    });
    if (!resp.ok) throw new Error(`Error ${resp.status} al consultar el servidor`);
    const data = await resp.json();
    if (data.ok === false) throw new Error(data.msg || "El servidor rechazó la consulta");
    return data.obj || {};
}

export const api = {
    raices: (signal) => post("raices", {}, signal),
    tipos: (raices, signal) => post("tipos", { raices }, signal),
    estados: (raices, tipos, signal) => post("estados", { raices, tipos }, signal),
    rangos: (raices, tipos, base, signal) => post("rangos", { raices, tipos, base }, signal),
    areas: (raices, signal) => post("areas", { raices }, signal),
    objetos: (param, signal) => post("objetos", param, signal),
    resueltos: (raices, signal) => post("resueltos", { raices }, signal),
    reportar: (param, signal) => post("reportar", param, signal),
    seguimiento: (codigo, signal) => post("seguimiento", { codigo }, signal),
};
